import { render } from "./Register_3.vue?vue&type=template&id=046536d0&scoped=true"
import script from "./Register_3.vue?vue&type=script&lang=js"
export * from "./Register_3.vue?vue&type=script&lang=js"

import "./Register_3.vue?vue&type=style&index=0&id=046536d0&scoped=true&lang=css"

import exportComponent from "B:\\GitHub\\Nakronpao\\Nakronpao-health\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046536d0"]])

export default __exports__